import {
  getCustomerDrawerOptions,
  getCustomerNetAcquisitionLimitDrawerOptions,
  getMarketAccountOptions,
  IconName,
  type ColumnDef,
  type Customer,
  type ICustomerNetAcquisitionLimit,
  type ICustomerNetAcquisitionLimitMembership,
  type InputsAndDropdownsDrawerOption,
  type MarketAccount,
} from '@talos/kyoko';

export const ACQUISITION_LIMIT_MEMBERSHIP_COLUMNS: ColumnDef<ICustomerNetAcquisitionLimitMembership>[] = [
  {
    id: 'counterparty',
    type: 'counterpartyFromMarketAccount',
    title: 'Counterparty',
    params: {
      marketAccountNameField: 'MarketAccount',
    },
    initialSort: '+',
  },
  {
    type: 'marketAccount',
    field: 'MarketAccount',
    initialSort: '+',
  },
  {
    type: 'text',
    field: 'AcquisitionLimit',
  },
];

export interface AcquisitionLimitMembershipDrawerEntity extends ICustomerNetAcquisitionLimitMembership {
  _Counterparty: string;
}

export function getAcquisitionLimitMembershipDrawerOptions(
  customers: Customer[],
  customerMarketAccountsList: MarketAccount[],
  acquisitionLimits: ICustomerNetAcquisitionLimit[]
): InputsAndDropdownsDrawerOption<AcquisitionLimitMembershipDrawerEntity>[] {
  return [
    {
      field: '_Counterparty',
      type: 'dropdown',
      title: 'Customer',
      getDropdownOptions: () => getCustomerDrawerOptions(customers),
      getIsRequired: () => true,
      disabledWhenEditing: true,
      onChange: (newValue, onFormUpdate) => onFormUpdate('MarketAccount', ''),
    },
    {
      field: 'MarketAccount',
      type: 'dropdown',
      getIsDisabled: form => !form._Counterparty,
      getDropdownOptions: form => {
        const filteredMarketAccounts = customerMarketAccountsList.filter(
          mktAcnt => mktAcnt.Counterparty === form._Counterparty
        );
        return getMarketAccountOptions(filteredMarketAccounts);
      },
      getIsRequired: () => true,
      disabledWhenEditing: true,
    },
    {
      field: 'AcquisitionLimit',
      type: 'dropdown',
      title: 'Limit Name',
      getDropdownOptions: () => getCustomerNetAcquisitionLimitDrawerOptions(acquisitionLimits),
      getIsRequired: () => true,
    },
  ];
}

export function getAcquisitionLimitMembershipAsDrawerEntity(
  membership: ICustomerNetAcquisitionLimitMembership,
  customerMarketAccountsByName: Map<string, MarketAccount>
): AcquisitionLimitMembershipDrawerEntity {
  const counterparty = customerMarketAccountsByName?.get(membership.MarketAccount)?.Counterparty;

  return {
    ...membership,
    _Counterparty: counterparty ?? '',
  };
}

export function viewStatusMenuItem(action: () => unknown) {
  return {
    name: 'View Status',
    action,
    icon: `<i class="ag-icon ${IconName.DocumentText}"/>`,
  };
}
